export interface AppStore {
  id: 'bazaar' | 'googleplay' | 'myket' | 'direct';
  label: string;
  href: string;
  icon: string;
}

const PACKAGE_ID = 'com.paziresh24.paziresh24';

// Served from public/apps so every deploy ships it. The file used to be copied onto the PHP
// server by hand and a deploy wiped it (404 since at least 2026-08-19), which silently shut
// the only install channel no store controls.
export const DIRECT_APK_PATH = '/apps/paziresh24.apk';

export const APP_STORES: AppStore[] = [
  {
    id: 'bazaar',
    label: 'دریافت از کافه‌بازار',
    href: `https://cafebazaar.ir/app/${PACKAGE_ID}/`,
    icon: '/img/app-download/bazaar.png',
  },
  {
    id: 'googleplay',
    label: 'دریافت از گوگل‌پلی',
    href: `https://play.google.com/store/apps/details?id=${PACKAGE_ID}`,
    icon: '/img/app-download/googleplay.png',
  },
  {
    id: 'myket',
    label: 'دریافت از مایکت',
    href: `https://myket.ir/app/${PACKAGE_ID}/`,
    icon: '/img/app-download/myket.png',
  },
  {
    id: 'direct',
    label: 'دانلود مستقیم فایل نصب (اندروید)',
    href: DIRECT_APK_PATH,
    icon: '/img/app-download/logopzdl.png',
  },
];

export const CELL_PATTERN = /^09\d{9}$/;
